module.exports = __webpack_public_path__ + "media/images/menu-icons/videos-02753b7c1e592970924cdcd14c99901b.svg";